export type CalculatorIconType =
	| "travelInsurance"
	| "carMotoInsurance"
	| "propertyInsurance"
	| "consumerLoan"
	| "mortgage"
	| "pensionAnnuity";

export const CALCULATOR_ICON_SIZE = 24;
export const CALCULATOR_ICON_VIEW_BOX = "0 0 24 24";
export const CALCULATOR_ICON_STROKE_WIDTH = 2;

export const CALCULATOR_ICON_PATHS: Record<CalculatorIconType, string[]> = {
	travelInsurance: [
		"M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
	],
	carMotoInsurance: [
		"M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
		"M9 17h6",
		"M5 17a2 2 0 1 0 4 0 2 2 0 1 0-4 0",
		"M15 17a2 2 0 1 0 4 0 2 2 0 1 0-4 0",
	],
	propertyInsurance: [
		"M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
		"M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
	],
	consumerLoan: [
		"M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z",
		"M2 10h20",
	],
	mortgage: [
		"M12 2 20 7 4 7Z",
		"M3 22h18",
		"M6 18v-7",
		"M10 18v-7",
		"M14 18v-7",
		"M18 18v-7",
	],
	pensionAnnuity: ["M22 7 13.5 15.5 8.5 10.5 2 17", "M16 7h6v6"],
};
